window.baseVm = null;

window.uuid = function(){
    var withLine = true;
    var len = 36;
    var radix = 16;
    var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
    var uuid = [], i;
    radix = radix || chars.length;
    if (withLine) {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < len; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16;
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
            }
        }
    } else {
        for (i = 0; i < len; i++) {
            uuid[i] = chars[0 | Math.random() * radix];
        }
    }
    return uuid.join('');
}

window.Base64 = function() {
  // private property
  var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  // public method for encoding
  this.encode = function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = _utf8_encode(input);
      while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
              enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
              enc4 = 64;
          }
          output = output +
          _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }
      return output;
  }

  // public method for decoding
  this.decode = function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
              output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
              output = output + String.fromCharCode(chr3);
          }
      }
      output = _utf8_decode(output);
      return output;
  }

  // private method for UTF-8 encoding
  var _utf8_encode = function (string) {
      string = string.replace(/\r\n/g,"\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
              utftext += String.fromCharCode(c);
          } else if((c > 127) && (c < 2048)) {
              utftext += String.fromCharCode((c >> 6) | 192);
              utftext += String.fromCharCode((c & 63) | 128);
          } else {
              utftext += String.fromCharCode((c >> 12) | 224);
              utftext += String.fromCharCode(((c >> 6) & 63) | 128);
              utftext += String.fromCharCode((c & 63) | 128);
          }

      }
      return utftext;
  }

  // private method for UTF-8 decoding
  var _utf8_decode = function (utftext) {
      var string = "";
      var i = 0;
      var c = c1 = c2 = 0;
      while ( i < utftext.length ) {
          c = utftext.charCodeAt(i);
          if (c < 128) {
              string += String.fromCharCode(c);
              i++;
          } else if((c > 191) && (c < 224)) {
              c2 = utftext.charCodeAt(i+1);
              string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
              i += 2;
          } else {
              c2 = utftext.charCodeAt(i+1);
              c3 = utftext.charCodeAt(i+2);
              string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
              i += 3;
          }
      }
      return string;
  }
}

Array.prototype.remove = function(val) {
    if($.isArray(val)){
      for(var i = 0 ; i < val.length ; i++){
        this.remove(val[i]);
      }
    }else{
      var index = this.indexOf(val);
      if (index > -1) {
        this.splice(index, 1);
      }
    }
};

/**
 * 日期格式化
 * @param {*} date 时间对象
 * @param {*} fmt 'yyyy-MM-dd hh:mm:ss'
 * @returns
 */
 const formatDate = window.formatDate = function (date, fmt) {
	if (!date) return ''
	if (!date.getFullYear) {
		date = new Date(date)
	}

	// 正则替换对应年月日
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	let o = {
		'M+': date.getMonth() + 1,
		'd+': date.getDate(),
		'h+': date.getHours(),
		'm+': date.getMinutes(),
		's+': date.getSeconds(),
	}
	for (let k in o) {
		if (new RegExp(`(${k})`).test(fmt)) {
			let str = o[k] + ''
			fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
		}
	}
	return fmt
}
function padLeftZero(str) {
	return ('00' + str).substr(str.length)
}


/**
 * 解析判断为有效 JSON
 * @param {*} str
 * @returns {false|object}
 */
JSON.parse2JSON = function parse2JSON (str) {
  try {
    let json = JSON.parse(str)
    if (json && typeof json === 'object') {
      return json
    }
    console.warn('解析JSON：', str, '\n')
    return false
  } catch (e) {
    console.warn('解析JSON：', str, '\n', e)
    return false
  }
}

/**
 * 为树节点添加属性
 * @param {[]} tree - 树节点
 * @param {object} props
 * @param {string} [props.childrenProp = 'nodes']
 * @param {(node: object, pos: [number]) => object} processNode
 *
 * @description 纯函数，不会改变源数据
 */
window.treeNodeAddProp = (tree, { childrenProp = 'nodes', initPos = [0] }, processNode) => {
  let childrenNode = (dataTree, parentPos) => {
    return dataTree.map((item, index) => {
      let pos = parentPos.concat(index);

      item = typeof processNode === 'function' && processNode(item, pos);

      if (item[childrenProp] && item[childrenProp].length) {
        return { ...item, [childrenProp]: childrenNode(item[childrenProp], pos) };
      }

      return { ...item };
    });
  };

  return childrenNode(tree, initPos);
};

window.list2tree2 = function (
  list,
  { valRootPid = 'null', propPid = 'parentId', idKey = 'id', childrenKey = 'children' } = {},
  processItem, status
) {
  let listTmp = list;
  if (typeof processItem === 'function') {
    listTmp = list.map((item) => {
      let itemTmp = status ? processItem({ ...item.node }) || item.node : processItem({ ...item }) || item ;
      return itemTmp;
    });
  }

  const group = {};
  listTmp.forEach((item) => {
    const parentId = item[propPid];
    if (!group.hasOwnProperty(parentId)) {
      group[parentId] = [];
    }
    group[parentId].push(item);
  });

  listTmp.forEach(function (item) {
    var id = item[idKey];
    if (group.hasOwnProperty(id)) {
      item[childrenKey] = group[id];
    }
  });

  return group[valRootPid];
}




// WEBPACK FOOTER //
// ./src/support/entrypoint.js